let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hlkXx")).then(() => parcelRequire('v9BTs'));